import { render, staticRenderFns } from "./FEL.vue?vue&type=template&id=97510ea6"
import script from "./FEL.vue?vue&type=script&lang=js"
export * from "./FEL.vue?vue&type=script&lang=js"
import style0 from "./FEL.vue?vue&type=style&index=0&id=97510ea6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports